module.exports = __webpack_public_path__ + "static/colorRelianceYes-9db04ab241bb4e1b554d20679355e7ca.png";